import React, { useState, useEffect, useRef } from 'react';
import { Header, PageContainer, Content } from '../Drawer/PageContainer';
import Loader from '../Shared/Loader/loader';
import Alice from '../Display/Alice';
import Scrollable from '../Shared/Edit/Scrollable';
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import InnerLoader from '../Shared/Loader/InnerLoader';
import ErrorMessage from '../Shared/Error/ErrorMessage';
import { Checkbox, NumericTextBox } from '@progress/kendo-react-inputs';
import { callApiWithAuthorization } from '../../API/CallApi';
import { ButtonGroup } from "@progress/kendo-react-buttons";
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { createSubscription, getSubscriptions, updateSubscription } from '../../API/Subscription/SubscriptionHelper';

const SubscriptionPortal = () => {
    const [state, setState] = useState({
        subscriptions: [],
        allSubscriptions: [],
        loading: true,
        showSubscriptionDialog: false,
        nameError: {
            isValid: true,
            message: "",
        },
        subscriptionName: "",
        private: false,
        monthlySeatPrice: 0.0,
        annuallySeatPrice: 0.0,
        maxApps: 1,
        maxSeats: 2,
        maxPortalsPerApp: 1,
        maxEntitiesPerApp: 2,
        maxAttributesPerApp: 3,
        maxRelationsPerApp: 1,
        showPortalLogos: false,
        showMasterApp: false,
        showApiPerApp: false,
        rolesPermission: "Full access",
        showCalculatedField: true,
        maxRecordsPerApp: 200,
        useCustomSignup: false,
        copilotAi: true,
        maxDatasizePerApp: 500,
        maxListPerApp: 10,
        maxChartsPerApp: 10,
        maxDashboardPerApp: 1,
        maxReportPerApp: 1,
        numDevInstances: 0,
        numTestInstances: 0,
        numProdInstances: 0,
        numOfTenantApps: 0,
        numRecordsInDevAndTestInstances: 0,
        numOfLimitedAccessRole: 0,
        numOfLimitedAccessUsers: 5,
        numOfReadOnlyObjects: 1,
        numOfSelfOnlyObjects: 1,
        numOfLanguages: 1,
        maxDummyRecordsInternal: 0,
        maxDummyRecordsAI: 0,
        showInstances: false,
        showPlanning: true,
        showHistory: 7,
        copilotAI: true,
        toUpdateId: "",
        toDeleteSubscription: {},
        processingSubscription: false,
        disabled: true,
    });

    const saveBtn = useRef(null);
    const arrayFromZeroToFive = [0, 1, 2, 3, 4, 5];
    const arrayFromZeroTofifteen = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
    const aaryFromZeroToHundred = Array.from({ length: 101 }, (_, i) => i);

    useEffect(() => {
        const fetchSubscriptions = async () => {
            let subscriptions = await getSubscriptions();
            for (let i = 0; i < subscriptions.length; i++) {
                subscriptions[i].indexId = i + 1;
            }
            setState((prevState) => ({
                ...prevState,
                subscriptions,
                allSubscriptions: subscriptions,
                loading: false,
            }));
        };
        fetchSubscriptions();
    }, []);

    const toggleSubscriptionDailog = () => {
        setState((prevState) => ({
            ...prevState,
            showSubscriptionDialog: !prevState.showSubscriptionDialog,
            subscriptionName: "",
            toUpdateId: "",
            toDeleteSubscription: {},
            private: false,
            monthlySeatPrice: 0.0,
            annuallySeatPrice: 0.0,
            maxApps: 1,
            maxSeats: 2,
            maxPortalsPerApp: 1,
            maxEntitiesPerApp: 2,
            maxAttributesPerApp: 3,
            maxRelationsPerApp: 1,
            showPortalLogos: false,
            showApiPerApp: false,
            showMasterApp: false,
            rolesPermission: "Full access",
            showCalculatedField: true,
            maxRecordsPerApp: 200,
            useCustomSignup: false,
            copilotAi: true,
            maxDatasizePerApp: 500,
            maxListPerApp: 10,
            maxChartsPerApp: 10,
            maxDashboardPerApp: 1,
            maxReportPerApp: 1,
            numDevInstances: 0,
            numTestInstances: 0,
            numProdInstances: 0,
            numOfTenantApps: 0,
            numOfLanguages: 1,
            maxDummyRecordsInternal: 0,
            maxDummyRecordsAI: 0,
            numRecordsInDevAndTestInstances: 0,
            numOfLimitedAccessRole: 0,
            numOfLimitedAccessUsers: 5,
            numOfReadOnlyObjects: 1,
            numOfSelfOnlyObjects: 1,
            showInstances: false,
            showPlanning: true,
            showHistory: 7,
            copilotAI: true,
            nameError: {
                isValid: true,
                message: "",
            }
        }));
    };

    const setPropertiesOnEdit = (dataItem) => {
        debugger
        setState((prevState) => ({
            ...prevState,
            showSubscriptionDialog: true,
            subscriptionName: dataItem.subscriptionName,
            private: dataItem.private,
            monthlySeatPrice: dataItem.monthlySeatPrice,
            annuallySeatPrice: dataItem.annuallySeatPrice,
            maxApps: dataItem.maxApps,
            maxSeats: dataItem.maxSeats,
            maxPortalsPerApp: dataItem.maxPortalsPerApp,
            maxEntitiesPerApp: dataItem.maxEntitiesPerApp,
            maxAttributesPerApp: dataItem.maxAttributesPerApp,
            maxRelationsPerApp: dataItem.maxRelationsPerApp,
            showPortalLogos: dataItem.showPortalLogos,
            showApiPerApp: dataItem.showApiPerApp,
            showMasterApp: dataItem.showMasterApp || false,
            rolesPermission: dataItem.rolesPermission,
            showCalculatedField: dataItem.showCalculatedField,
            maxRecordsPerApp: dataItem.maxRecordsPerApp,
            useCustomSignup: dataItem.useCustomSignup,
            copilotAi: dataItem.copilotAi,
            maxDatasizePerApp: dataItem.maxDatasizePerApp,
            maxListPerApp: dataItem.maxListPerApp,
            maxChartsPerApp: dataItem.maxChartsPerApp,
            maxDashboardPerApp: dataItem.maxDashboardPerApp,
            maxReportPerApp: dataItem.maxReportPerApp,
            showPlanning: dataItem.showPlanning,
            showHistory: dataItem.showHistory,
            numDevInstances: dataItem.numDevInstances || 0,
            numTestInstances: dataItem.numTestInstances || 0,
            numProdInstances: dataItem.numProdInstances || 0,
            numOfTenantApps: dataItem.numOfTenantApps,
            numOfLanguages: dataItem.numOfLanguages,
            maxDummyRecordsInternal: dataItem.maxDummyRecordsInternal || 0,
            maxDummyRecordsAI: dataItem.maxDummyRecordsAI || 0,
            numRecordsInDevAndTestInstances: dataItem.numRecordsInDevAndTestInstances,
            numOfLimitedAccessRole: dataItem.numOfLimitedAccessRole || 0,
            numOfLimitedAccessUsers: dataItem.numOfLimitedAccessUsers || 5,
            numOfReadOnlyObjects: dataItem.numOfReadOnlyObjects || 1,
            numOfSelfOnlyObjects: dataItem.numOfSelfOnlyObjects || 1,
            showInstances: dataItem.showInstances,
            toUpdateId: dataItem._id,
            copilotAI: dataItem.copilotAI === undefined ? true : dataItem.copilotAI,
        }));
    };

    const handlePrivate = (e) => {
        setState((prevState) => ({ ...prevState, private: e.value }));
    };

    const handleSubscriptionName = (e) => {
        let { nameError } = state;
        let subscriptionName = e.target.value.trim();
        let specialCharactersEntered = /[^a-zA-Z0-9 ]/g.test(subscriptionName);
        if (subscriptionName === "") {
            nameError.isValid = false;
            nameError.message = "Subscription name is required";
        } else if (subscriptionName.match(/^\d/)) {
            nameError.isValid = false;
            nameError.message = "Subscription name cannot start with number";
        } else if (specialCharactersEntered) {
            nameError.isValid = false;
            nameError.message = "Subscription name cannot have special character";
        } else {
            let exist = state.allSubscriptions.find(
                (item) =>
                    item.subscriptionName
                        .toLowerCase()
                        .replace(/[^a-zA-Z0-9]/g, "") ===
                    subscriptionName.toLowerCase().replace(/[^a-zA-Z0-9]/g, "")
            );
            if (exist) {
                nameError.isValid = false;
                nameError.message = "Subscription with that name already exists";
            } else {
                nameError.isValid = true;
                nameError.message = "";
            }
        }
        setState((prevState) => ({
            ...prevState,
            subscriptionName: e.target.value,
            nameError: nameError,
        }));
    };

    const handleChange = (e) => {
        let { name, value } = e.target;
        setState((prevState) => ({
            ...prevState,
            [name]: value,
            ...(name === "copilotAi" ? { copilotAI: value } : {}),
            ...(name === "copilotAI" ? { copilotAi: value } : {}),
        }));
    };

    const shouldDisable = () => {
        if (state.subscriptionName.trim() === "") {
            return true;
        } else if (!state.nameError.isValid) {
            return true;
        } else {
            return (
                state.monthlySeatPrice === null ||
                state.annuallySeatPrice === null ||
                state.maxApps === null ||
                state.maxSeats === null ||
                state.maxPortalsPerApp === null ||
                state.maxEntitiesPerApp === null ||
                state.maxAttributesPerApp === null ||
                state.maxRelationsPerApp === null ||
                state.maxRecordsPerApp === null ||
                state.useCustomSignup === null ||
                state.copilotAi === null ||
                state.maxDatasizePerApp === null ||
                state.maxListPerApp === null ||
                state.maxChartsPerApp === null ||
                state.maxDashboardPerApp === null ||
                state.maxReportPerApp === null
            );
        }
    };

    const onUpdate = async (e) => {
        e.preventDefault();
        saveBtn.current.disabled = true;
        setState((prevState) => ({ ...prevState, processingSubscription: true }));

        const updatedProperties = {
            subscriptionName: state.subscriptionName.trim(),
            private: state.private,
            monthlySeatPrice: state.monthlySeatPrice,
            annuallySeatPrice: state.annuallySeatPrice,
            maxApps: state.maxApps,
            maxSeats: state.maxSeats,
            maxPortalsPerApp: state.maxPortalsPerApp,
            maxEntitiesPerApp: state.maxEntitiesPerApp,
            maxAttributesPerApp: state.maxAttributesPerApp,
            maxRelationsPerApp: state.maxRelationsPerApp,
            rolesPermission: state.rolesPermission,
            showPortalLogos: state.showPortalLogos,
            showApiPerApp: state.showApiPerApp,
            showMasterApp: state.showMasterApp,
            showCalculatedField: state.showCalculatedField,
            maxRecordsPerApp: state.maxRecordsPerApp,
            useCustomSignup: state.useCustomSignup,
            copilotAi: state.copilotAi,
            maxDatasizePerApp: state.maxDatasizePerApp,
            maxListPerApp: state.maxListPerApp,
            maxChartsPerApp: state.maxChartsPerApp,
            maxDashboardPerApp: state.maxDashboardPerApp,
            maxReportPerApp: state.maxReportPerApp,
            numDevInstances: state.numDevInstances,
            numOfLanguages: state.numOfLanguages,
            maxDummyRecordsInternal: state.maxDummyRecordsInternal,
            maxDummyRecordsAI: state.maxDummyRecordsAI,
            numTestInstances: state.numTestInstances,
            numProdInstances: state.numProdInstances,
            numOfTenantApps: state.numOfTenantApps,
            numRecordsInDevAndTestInstances: state.numRecordsInDevAndTestInstances,
            numOfLimitedAccessRole: state.numOfLimitedAccessRole,
            numOfLimitedAccessUsers: state.numOfLimitedAccessUsers,
            numOfReadOnlyObjects: state.numOfReadOnlyObjects,
            numOfSelfOnlyObjects: state.numOfSelfOnlyObjects,
            showInstances: state.showInstances,
            showPlanning: state.showPlanning,
            showHistory: state.showHistory,
            copilotAI: state.copilotAI,
        };

        await updateSubscription(state.toUpdateId, updatedProperties);

        const updatedSubscriptions = state.subscriptions.map(subscription =>
            subscription._id === state.toUpdateId
                ? { ...subscription, ...updatedProperties }
                : subscription
        );

        setState((prevState) => ({
            ...prevState,
            subscriptions: updatedSubscriptions,
            allSubscriptions: updatedSubscriptions,
            processingSubscription: false,
            showSubscriptionDialog: false,
            toUpdateId: "",
        }));
    };

    const onCreate = async (e) => {
        e.preventDefault();
        saveBtn.current.disabled = true;
        setState((prevState) => ({ ...prevState, processingSubscription: true }));

        const stripeProduct = await createProductOnStripe();

        const subscriptionProperties = {
            subscriptionName: state.subscriptionName.trim(),
            private: state.private,
            monthlySeatPrice: state.monthlySeatPrice,
            annuallySeatPrice: state.annuallySeatPrice,
            maxApps: state.maxApps,
            maxSeats: state.maxSeats,
            maxPortalsPerApp: state.maxPortalsPerApp,
            maxEntitiesPerApp: state.maxEntitiesPerApp,
            maxAttributesPerApp: state.maxAttributesPerApp,
            maxRelationsPerApp: state.maxRelationsPerApp,
            rolesPermission: state.rolesPermission,
            showPortalLogos: state.showPortalLogos,
            showApiPerApp: state.showApiPerApp,
            showMasterApp: state.showMasterApp,
            showCalculatedField: state.showCalculatedField,
            stripeProductId: stripeProduct.id,
            maxRecordsPerApp: state.maxRecordsPerApp,
            useCustomSignup: state.useCustomSignup,
            copilotAi: state.copilotAi,
            maxDatasizePerApp: state.maxDatasizePerApp,
            maxListPerApp: state.maxListPerApp,
            maxChartsPerApp: state.maxChartsPerApp,
            maxDashboardPerApp: state.maxDashboardPerApp,
            maxReportPerApp: state.maxReportPerApp,
            showPlanning: state.showPlanning,
            showHistory: state.showHistory,
            numDevInstances: state.numDevInstances,
            numOfLanguages: state.numOfLanguages,
            maxDummyRecordsInternal: state.maxDummyRecordsInternal,
            maxDummyRecordsAI: state.maxDummyRecordsAI,
            numTestInstances: state.numTestInstances,
            numProdInstances: state.numProdInstances,
            numOfTenantApps: state.numOfTenantApps,
            showInstances: state.showInstances,
            numRecordsInDevAndTestInstances: state.numRecordsInDevAndTestInstances,
            numOfLimitedAccessRole: state.numOfLimitedAccessRole,
            numOfLimitedAccessUsers: state.numOfLimitedAccessUsers,
            numOfReadOnlyObjects: state.numOfReadOnlyObjects,
            numOfSelfOnlyObjects: state.numOfSelfOnlyObjects,
            archived: false,
            copilotAI: state.copilotAI,
        };

        await createSubscription(subscriptionProperties);

        let updatedSubscriptions = [...state.subscriptions, subscriptionProperties];
        for (let i = 0; i < updatedSubscriptions.length; i++) {
            updatedSubscriptions[i].indexId = i + 1;
        }

        setState((prevState) => ({
            ...prevState,
            subscriptions: updatedSubscriptions,
            allSubscriptions: updatedSubscriptions,
            processingSubscription: false,
            showSubscriptionDialog: false,
        }));
    };

    const createProductOnStripe = async () => {
        const { subscriptionName: productName } = state;
        const prices = createPricesArrayForStripe();
        const createProductRequest = await callApiWithAuthorization("/api/v0/subscription/product", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                productName,
                prices,
                private: state.private,
            }),
        });
        const product = await createProductRequest.json();
        return product;
    };

    const createPricesArrayForStripe = () => {
        const { monthlySeatPrice, annuallySeatPrice } = state;
        return [
            {
                interval: "month",
                amount: Number(monthlySeatPrice),
            },
            {
                interval: "year",
                amount: Number(annuallySeatPrice),
            },
        ];
    };

    const searchSubscriptions = (e) => {
        let searchValue = e.target.value.toLowerCase();
        let filteredSubscriptions = state.allSubscriptions.filter(
            (subscription) =>
                subscription.subscriptionName.toLowerCase().includes(searchValue)
        );
        setState((prevState) => ({
            ...prevState,
            subscriptions: filteredSubscriptions,
        }));
    }

    return (
        <PageContainer>
            <Header
                showAction={true}
                header="Subscriptions"
                actionText="New Subscription Plan"
                actionClicked={toggleSubscriptionDailog}
                actionTitle="Create new Subscription"
                actionIcon="fas fa-plus"
            >
                {state.allSubscriptions.length !== 0 && (
                    <div className="d-flex me-2">
                        <input
                            style={{ width: 250 }}
                            type="text"
                            onChange={searchSubscriptions}
                            placeholder="&#xf002; &nbsp; Search subscriptions"
                            className="form-control unicode"
                        />
                    </div>
                )}
            </Header>
            {state.showSubscriptionDialog && (
                <Dialog
                    width={"80%"}
                    height={"90%"}
                    title={
                        state.toUpdateId === ""
                            ? "Create Subscription Plan"
                            : "Update Subscription Plan"
                    }
                    onClose={toggleSubscriptionDailog}
                >
                    <div>
                        <div className="form-label d-inline-block" required>
                            Name
                        </div>
                        <ErrorMessage
                            valid={state.nameError.isValid}
                            error={state.nameError.message}
                        />
                        <input
                            maxLength="64"
                            name="subscriptionName"
                            className="name-text form-control"
                            disabled={state.toUpdateId !== ""}
                            onChange={handleSubscriptionName}
                            value={state.subscriptionName}
                            autoFocus={true}
                        />
                        <div className="d-block mt-2">
                            <div className="form-label d-inline-block pe-3">
                                Private
                            </div>
                            <Checkbox
                                disabled={state.toUpdateId !== ""}
                                onChange={handlePrivate}
                                checked={state.private}
                            />
                        </div>
                        <br />
                        <h5>Designer Parameters</h5>
                        <div className="form-row m-2">
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Price per seat monthly (USD)
                                </div>
                                <NumericTextBox
                                    min={0}
                                    disabled={state.toUpdateId !== ""}
                                    format="n2"
                                    name="monthlySeatPrice"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    required={true}
                                    value={state.monthlySeatPrice}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Price per seat annually (USD)
                                </div>
                                <NumericTextBox
                                    min={0}
                                    disabled={state.toUpdateId !== ""}
                                    required={true}
                                    format="n2"
                                    name="annuallySeatPrice"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.annuallySeatPrice}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Max apps
                                </div>
                                <NumericTextBox
                                    min={0}
                                    required={true}
                                    format="n0"
                                    name="maxApps"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.maxApps}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Max of seats per organization
                                </div>
                                <NumericTextBox
                                    min={0}
                                    required={true}
                                    format="n0"
                                    name="maxSeats"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.maxSeats}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Max portals per app
                                </div>
                                <NumericTextBox
                                    min={0}
                                    required={true}
                                    format="n0"
                                    name="maxPortalsPerApp"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.maxPortalsPerApp}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Max entities per app
                                </div>
                                <NumericTextBox
                                    min={0}
                                    required={true}
                                    format="n0"
                                    name="maxEntitiesPerApp"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.maxEntitiesPerApp}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Max attributes per entity
                                </div>
                                <NumericTextBox
                                    min={0}
                                    required={true}
                                    format="n0"
                                    name="maxAttributesPerApp"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.maxAttributesPerApp}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Max entity relations per app
                                </div>
                                <NumericTextBox
                                    min={0}
                                    required={true}
                                    format="n0"
                                    name="maxRelationsPerApp"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.maxRelationsPerApp}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Role Management
                                </div>
                                <DropDownList
                                    data={[
                                        "Full access",
                                        "Editable",
                                        "Read only"
                                    ]}
                                    required={true}
                                    name="rolesPermission"
                                    value={state.rolesPermission}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Portal Logos
                                </div>
                                <Checkbox
                                    name="showPortalLogos"
                                    onChange={handleChange}
                                    checked={state.showPortalLogos}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Instances
                                </div>
                                <Checkbox
                                    name="showInstances"
                                    onChange={handleChange}
                                    checked={state.showInstances}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    API
                                </div>
                                <Checkbox
                                    name="showApiPerApp"
                                    onChange={handleChange}
                                    checked={state.showApiPerApp}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Master App
                                </div>
                                <Checkbox
                                    name="showMasterApp"
                                    onChange={handleChange}
                                    checked={state.showMasterApp}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-3 pe-3">
                                <div className="form-label">
                                    # of Dev Enviroment(Master)
                                </div>
                                <DropDownList
                                    data={arrayFromZeroToFive}
                                    required={true}
                                    name="numDevInstances"
                                    value={state.numDevInstances}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    # of Test Enviroment(Master)
                                </div>
                                <DropDownList
                                    data={arrayFromZeroToFive}
                                    required={true}
                                    name="numTestInstances"
                                    value={state.numTestInstances}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    # of Prod Enviroment(Master)
                                </div>
                                <DropDownList
                                    data={arrayFromZeroToFive}
                                    required={true}
                                    name="numProdInstances"
                                    value={state.numProdInstances}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    # of Tenant Apps
                                </div>
                                <DropDownList
                                    data={aaryFromZeroToHundred}
                                    required={true}
                                    name="numOfTenantApps"
                                    value={state.numOfTenantApps}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    # of Records in Dev & Test Instance
                                </div>
                                <NumericTextBox
                                    min={0}
                                    format="n0"
                                    name="numRecordsInDevAndTestInstances"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.numRecordsInDevAndTestInstances}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    # of Languages
                                </div>
                                <DropDownList
                                    data={arrayFromZeroTofifteen}
                                    name="numOfLanguages"
                                    value={state.numOfLanguages}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <br />
                        <h5>Runtime Parameters</h5>
                        <div className="form-row m-2">
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    # of Limited Access Role
                                </div>
                                <NumericTextBox
                                    min={0}
                                    max={3}
                                    format="n0"
                                    required={true}
                                    name="numOfLimitedAccessRole"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.numOfLimitedAccessRole}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    # of Limited Access Users
                                </div>
                                <NumericTextBox
                                    min={0}
                                    max={10000000}
                                    format="n0"
                                    required={true}
                                    name="numOfLimitedAccessUsers"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.numOfLimitedAccessUsers}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    # of Read-Only Objects
                                </div>
                                <NumericTextBox
                                    min={0}
                                    max={5}
                                    format="n0"
                                    required={true}
                                    name="numOfReadOnlyObjects"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.numOfReadOnlyObjects}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    # of Self-Only Access Objects
                                </div>
                                <NumericTextBox
                                    min={0}
                                    max={5}
                                    format="n0"
                                    required={true}
                                    name="numOfSelfOnlyObjects"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.numOfSelfOnlyObjects}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Max records per org
                                </div>
                                <NumericTextBox
                                    min={0}
                                    format="n0"
                                    required={true}
                                    name="maxRecordsPerApp"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.maxRecordsPerApp}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Max datasize per org (in mb)
                                </div>
                                <NumericTextBox
                                    min={0}
                                    required={true}
                                    format="n0"
                                    name="maxDatasizePerApp"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.maxDatasizePerApp}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Max list per org
                                </div>
                                <NumericTextBox
                                    min={0}
                                    required={true}
                                    format="n0"
                                    name="maxListPerApp"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.maxListPerApp}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Max charts per org
                                </div>
                                <NumericTextBox
                                    min={0}
                                    required={true}
                                    format="n0"
                                    name="maxChartsPerApp"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.maxChartsPerApp}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Max dashboard per org
                                </div>
                                <NumericTextBox
                                    min={0}
                                    required={true}
                                    format="n0"
                                    name="maxDashboardPerApp"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.maxDashboardPerApp}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Max report per org
                                </div>
                                <NumericTextBox
                                    min={0}
                                    required={true}
                                    format="n0"
                                    name="maxReportPerApp"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.maxReportPerApp}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    # of Dummy Records (Internal)
                                </div>
                                <NumericTextBox
                                    min={0}
                                    max={1000000}
                                    format="n0"
                                    name="maxDummyRecordsInternal"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.maxDummyRecordsInternal}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    # of AI Records (AI)
                                </div>
                                <NumericTextBox
                                    min={0}
                                    max={20}
                                    format="n0"
                                    name="maxDummyRecordsAI"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.maxDummyRecordsAI}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    History
                                </div>
                                <NumericTextBox
                                    min={0}
                                    max={1825}
                                    defaultValue={7}
                                    required={true}
                                    format="n0"
                                    name="showHistory"
                                    spinners={false}
                                    className="w-100"
                                    onChange={handleChange}
                                    value={state.showHistory}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Calculated field
                                </div>
                                <Checkbox
                                    name="showCalculatedField"
                                    checked={state.showCalculatedField}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Planning
                                </div>
                                <Checkbox
                                    name="showPlanning"
                                    checked={state.showPlanning}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Custom Signup
                                </div>
                                <Checkbox
                                    name="useCustomSignup"
                                    checked={state.useCustomSignup}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group d-inline-block col-md-2 pe-3">
                                <div className="form-label">
                                    Copilot AI
                                </div>
                                <Checkbox
                                    name="copilotAi"
                                    checked={state.copilotAi}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                    <DialogActionsBar layout="end">
                        <div className='mb-2 me-2'>
                            <small className="mt-1">
                                {state.processingSubscription && (
                                    <div className="d-inline-block">
                                        <InnerLoader borderColor="green" />
                                        <span className="me-4 text-success"></span>
                                    </div>
                                )}
                            </small>
                            <button
                                onClick={toggleSubscriptionDailog}
                                type={"button"}
                                className="btn btn-secondary mx-2"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={state.toUpdateId === "" ? onCreate : onUpdate}
                                type={"button"}
                                disabled={shouldDisable()}
                                ref={saveBtn}
                                className="btn btn-primary"
                            >
                                {state.toUpdateId === ""
                                    ? "Create"
                                    : "Update"}
                            </button>
                        </div>
                    </DialogActionsBar>
                </Dialog>
            )}
            {
                state.loading ? (
                    <Loader />
                ) : (
                    <Content>
                        {state.allSubscriptions.length === 0 ? (
                            <Alice mode="new" header="Create Subscriptions">
                                Create subscription to manage many aspects of
                                your business
                                <br />
                                <br />
                                Click on{" "}
                                <b className="mx-1">+ New Subscription</b>to
                                create your first subscription.
                            </Alice>
                        ) : (
                            <Scrollable>
                                <Grid
                                    data={state.subscriptions}
                                    resizable={true}
                                    reorderable={true}
                                >
                                    <Column field="indexId" title="#" width={60} />
                                    <Column
                                        field="subscriptionName"
                                        title="Subscription Plan"
                                        cell={props => (
                                            <td>
                                                {props.dataItem.subscriptionName}
                                                {props.dataItem.archived && <em>(Archived)</em>}
                                            </td>
                                        )}
                                    />
                                    <Column
                                        title="Private"
                                        cell={(props) => {
                                            return (
                                                <td>{props.dataItem.private ? "Yes" : "No"}</td>
                                            );
                                        }}
                                    />
                                    <Column
                                        field="monthlySeatPrice"
                                        title="Price per seat monthly (USD)"
                                    />
                                    <Column
                                        field="annuallySeatPrice"
                                        title="Price per seat annually (USD)"
                                    />
                                    <Column
                                        title=""
                                        cell={(props) => {
                                            return (
                                                <td className="float-end pe-3">
                                                    <ButtonGroup>
                                                        <button
                                                            onClick={() => setPropertiesOnEdit(props.dataItem)}
                                                            className="pe-3 btn btn-primary"
                                                        >
                                                            Edit
                                                        </button>
                                                    </ButtonGroup>
                                                </td>
                                            );
                                        }}
                                    />
                                </Grid>
                            </Scrollable>
                        )}
                    </Content>
                )
            }
        </PageContainer>
    );
};

export default SubscriptionPortal;
